import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { get, omit } from 'lodash';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import TimeReport from 'services/data/time-report';

// Components
import HelpText from './help-text';
import { DurationInput } from 'components/forms/form-elements';


// This is a component used to display help text only when the time report duration field is active
class TimeReportDurationInput extends React.Component { // eslint-disable-line react/prefer-stateless-function
  static propTypes = {
    meta: PropTypes.object.isRequired, // Prop from redux-form Field
    currentUser: PropTypes.object.isRequired,
    lastTimeReport: PropTypes.object
  };

  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    TimeReport.find({
      where: {
        createdBy: this.props.currentUser.id
      },
      limit: 1,
      sort: 'createdAt DESC'
    })
      .then((timeReport) => {
        this.setState({ lastTimeReport: timeReport[0] });
      })
      .catch(alerts.catchError);
  }

  render() {
    const { meta } = this.props;
    const { lastTimeReport } = this.state;

    const lastTRCreatedAt = get(lastTimeReport, 'createdAt');
    const minSinceLast = lastTRCreatedAt ? moment().diff(lastTimeReport.createdAt, 'minutes') : 0;
    const hoursSinceLast = (Math.round(minSinceLast / 60 * 4) / 4).toFixed(2);

    return (
      <div>
        <DurationInput {...omit(this.props, ['currentUser', 'dispatch'])} />
        <HelpText show={meta.active} container={this}>Use up/down arrow keys to increment by 0.25</HelpText>
        { (hoursSinceLast && hoursSinceLast > 0 && hoursSinceLast < 12) &&
          <span className="last-time-report">It's been {hoursSinceLast} hrs since you last entered a time report</span>
        }
      </div>
    );
  }
}

export default connect((state) => ({
  currentUser: state.auth.currentUser
}))(TimeReportDurationInput);



// WEBPACK FOOTER //
// ./app/components/forms/help-text/time-report-duration-input.js